export default __webpack_public_path__ + "static/media/vmlogo.f91ae042.png";